import type React from 'react'

import css from './styles.module.css'

export const StatsSkeleton: React.FC = () => {
  return (
    <div className={css.stats_skeleton}>
      <div className={css.item}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
      <div className={css.item}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
      <div className={css.item}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
    </div>
  )
}
